import { render, staticRenderFns } from "./VUserIcon.vue?vue&type=template&id=2d89be06"
import script from "./VUserIcon.vue?vue&type=script&lang=js"
export * from "./VUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports